module.exports = __webpack_public_path__ + "static/media/Roche.83df4034.jpg";